import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, NavLink} from "react-router-dom";
import {Helmet} from 'react-helmet';

class Four04 extends Component {
  constructor (props) {
    super(props)
  }

  componentDidMount () {
    window.scrollTo(0, 0)
    var header = document.getElementById("navigation");
    header.classList.remove('active');
    header.style.top = "0";
  }

  render() {
    return (
      <div className="single-page" id="404">
        <Helmet>
          <title>Bethard Universe || 404</title>
          <link rel="canonical" href={location.protocol + '//' + location.host} />
          <meta property="og:title" content="Bethard Universe || 404" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={location.href} />
          <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
        </Helmet>

        <div className="content-wrapper background">
          <div className="section-content">
            <div className="section-heading">OOPS</div>
            <div className="section-heading">ERROR 404</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Four04;



// WEBPACK FOOTER //
// ./client/components/pages/four04.jsx